import * as React from 'react';
import { TextField, FormControl, InputLabel, MenuItem, Select, Dialog, DialogActions, DialogContent, DialogTitle, Button, InputAdornment, Checkbox, FormControlLabel } from "@mui/material";
import logo from '../../assets/img/logo_alt.png';
import { useEffect, useState } from 'react';
import { ApiRequest, isValidRutCL } from "GlobalFunctions";
import LoadingButton from '@mui/lab/LoadingButton';
import Box from "elements/Box";
import AutocompleteField from "elements/AutocompleteField";
import { useSnackbar } from 'notistack';
import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from './firebase';
import GoogleIcon from '@mui/icons-material/Google';

export default function SignUp(props: any) {

    const [showEmailForm, setShowEmailForm] = useState(false);

    /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
    const { enqueueSnackbar } = useSnackbar();
    /*============================================= */

    const [fieldsCompleted, setFieldsCompleted] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);
    const [nurseAlertOpen, setNurseAlertOpen] = useState(false);
    const [commissionAccepted, setCommissionAccepted] = useState(false);
    const [commissionTerms, setCommissionTerms] = useState('');
    const defaultValues = {
        role_id: '' as number | '',
        name: '',
        lastname: '',
        phone: '',
        whatsapp: '',
        email: '',
        password: '',
        confirm_password: '',
        home_comuna_id: '' as number | '',
        locations: [] as any[],
        rut: '',
    }

    const [formValues, setFormValues] = useState(defaultValues);
    const [rutError, setRutError] = useState(false);

    const validateEmail = (email: string) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    }

    const checkFields = () => {
        let valid = true;
        if (formValues.name === '') valid = false;
        if (formValues.lastname === '') valid = false;
        if (formValues.phone === '') valid = false;
        if (formValues.email === '' || !validateEmail(formValues.email)) valid = false;
        if (formValues.password === '') valid = false;
        if (formValues.confirm_password === '') valid = false;
        if (formValues.password !== formValues.confirm_password) valid = false;
        if (formValues.role_id === 2 && formValues.home_comuna_id === '') valid = false;
        if (formValues.role_id === 2 && formValues.locations.length === 0) valid = false;
        if (formValues.role_id === 2 && !isValidRutCL(formValues.rut)) valid = false;

        setFieldsCompleted(valid);
    }

    useEffect(() => {
        if (localStorage.getItem('ltkn')) {
            window.location.href = '/';
        }
        ApiRequest({
            url: '/settings/details',
            method: 'GET',
            setResponse: (response: any) => {
                setCommissionTerms(response?.seo?.preferente_terms || '');
            },
        });
    }, []);

    const isKinesiologo = formValues.role_id === 2;
    const canProceed = formValues.role_id !== '' && formValues.phone.trim() !== ''
        && (!isKinesiologo || (
            commissionAccepted
            && isValidRutCL(formValues.rut)
            && formValues.home_comuna_id !== ''
            && formValues.locations.length > 0
        ));

    const submit = async () => {
        setLoadingButton(true);
        await ApiRequest({
            url: '/users/signup',
            method: 'POST',
            body: { ...formValues, commission_consent: isKinesiologo ? commissionAccepted : undefined },
            setResponse: (response: any) => {
                setLoadingButton(false);
                if (response.status === 'error') {
                    enqueueSnackbar(response.message, { variant: 'error' });
                } else if (formValues.role_id === 2) {
                    setNurseAlertOpen(true);
                } else {
                    window.location.href = '/login';
                }
            }
        });
        
    }

    const signUpWithGoogle = async () => {
        if (isKinesiologo && !commissionAccepted) return;
        try {
            setLoadingButton(true);
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;

            await ApiRequest({
                url: '/users/google-signup',
                method: 'POST',
                body: {
                    email: user.email,
                    name: user.displayName?.split(' ')[0] || '',
                    lastname: user.displayName?.split(' ').slice(1).join(' ') || '',
                    google_id: user.uid,
                    role_id: formValues.role_id,
                    phone: formValues.phone,
                    commission_consent: isKinesiologo ? commissionAccepted : undefined,
                    rut: isKinesiologo ? formValues.rut : undefined,
                    home_comuna_id: isKinesiologo ? formValues.home_comuna_id : undefined,
                    locations: isKinesiologo ? formValues.locations : undefined,
                },
                setResponse: (response: any) => {
                    setLoadingButton(false);
                    if (response.status === 'error') {
                        enqueueSnackbar(response.message, { variant: 'error' });
                    } else {
                        // Almacenar información de sesión
                        localStorage.setItem('ltkn', response.user_info.ltkn);
                        localStorage.setItem('user_name', response.user_info.user_name);
                        localStorage.setItem('role_id', response.user_info.role_id);
                        
                        enqueueSnackbar(response.message, { variant: 'success' });
                        window.location.href = '/'; // Redirigir al dashboard en lugar de login
                    }
                }
            });
        } catch (error) {
            console.error(error);
            enqueueSnackbar("Error al registrarse con Google", { variant: 'error' });
            setLoadingButton(false);
        }
    };

    useEffect(() => {
        checkFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formValues]);

    return (
        <>
            <Box id='loginBox' className='intent-auth_component'>

                <img className='loginLogo' src={logo} alt="" />

                <div className="input_group">

                    <FormControl fullWidth>
                      <InputLabel id="role-label">Seleccione tipo de usuario</InputLabel>
                      <Select
                          labelId="role-label"
                          id="role"
                          value={formValues.role_id}
                          label="Seleccione tipo de usuario"
                          onChange={(e) => setFormValues({ ...formValues, role_id: e.target.value as number })}
                      >
                          <MenuItem value={1}>Paciente</MenuItem>
                          <MenuItem value={2}>Kinesiólogo</MenuItem>
                      </Select>
                    </FormControl>

                    {isKinesiologo && (
                        <TextField
                            label="RUT"
                            value={formValues.rut}
                            onChange={(e) => {
                                setFormValues({ ...formValues, rut: e.target.value });
                                setRutError(e.target.value !== '' && !isValidRutCL(e.target.value));
                            }}
                            error={rutError}
                            helperText={rutError ? 'RUT inválido' : 'Obligatorio para registrarte como kinesiólogo'}
                            variant="outlined"
                            fullWidth
                            style={{ marginTop: '10px' }}
                        />
                    )}

                    {isKinesiologo && (
                        <div style={{ marginTop: '10px' }}>
                            <AutocompleteField
                                label="Comunas de atención"
                                endpoint="/locations/comunas/list"
                                renderValues={["label", "region"]}
                                multiple={true}
                                value={formValues.locations}
                                onChange={(data: any) => setFormValues({ ...formValues, locations: data ? data : [] })}
                            />
                        </div>
                    )}

                    {isKinesiologo && (
                        <div style={{ marginTop: '10px' }}>
                            <AutocompleteField
                                label="Comuna de residencia"
                                endpoint="/locations/comunas/list"
                                renderValues={["label", "region"]}
                                value={formValues.home_comuna_id}
                                onChange={(data: any) => setFormValues({ ...formValues, home_comuna_id: data ? data.comuna_id : '' })}
                            />
                        </div>
                    )}

                    {formValues.role_id !== '' && (
                        <TextField
                            label="Número de Teléfono"
                            value={formValues.phone}
                            onChange={(e) => setFormValues({ ...formValues, phone: e.target.value, whatsapp: e.target.value })}
                            variant="outlined"
                            fullWidth
                            style={{ marginTop: '10px' }}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">+56</InputAdornment>
                            }}
                            helperText={isKinesiologo ? 'Se usará también como WhatsApp de contacto' : ''}
                        />
                    )}

                    {isKinesiologo && (
                        <Box
                            style={{ marginTop: '10px', background: '#fffbeb', border: '1px solid #fbbf24' }}
                        >
                            <div style={{ fontWeight: 600, marginBottom: '6px', color: '#92400e' }}>Condiciones de Cobro por Derivación ($10.000)</div>
                            <div style={{ fontSize: '13px', color: '#78350f', lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: commissionTerms }} />
                            <FormControlLabel
                                control={<Checkbox checked={commissionAccepted} onChange={(e) => setCommissionAccepted(e.target.checked)} />}
                                label="Acepto estas condiciones"
                                style={{ marginTop: '8px' }}
                            />
                        </Box>
                    )}

                    {canProceed && (
                    <LoadingButton
                        size="small"
                        fullWidth
                        variant="outlined"
                        sx={{ fontSize: '13px', padding: '10px 0px', marginTop: '10px' }}
                        onClick={signUpWithGoogle}
                        disabled={loadingButton || formValues.role_id === ''}
                        loading={loadingButton}
                        startIcon={<GoogleIcon />}
                    >
                        Registrarme con Google
                    </LoadingButton>
                    )}

                    {canProceed && (
                    <LoadingButton
                        size="small"
                        fullWidth
                        variant="outlined"
                        sx={{ fontSize: '13px', padding: '10px 0px', marginTop: '10px' }}
                        onClick={() => setShowEmailForm(!showEmailForm)}
                        disabled={formValues.role_id === ''}
                    >
                        {showEmailForm ? 'Ocultar formulario de correo' : 'Registrarme con correo'}
                    </LoadingButton>
                    )}

                    {canProceed && showEmailForm && (
                        <>
                            <div className='input_row'>
                                <TextField
                                    label="Nombre"
                                    value={formValues.name}
                                    onChange={(e) => setFormValues({ ...formValues, name: e.target.value })}
                                    variant="outlined"
                                    fullWidth
                                />

                                <TextField
                                    label="Apellido"
                                    value={formValues.lastname}
                                    onChange={(e) => setFormValues({ ...formValues, lastname: e.target.value })}
                                    variant="outlined"
                                    fullWidth
                                />
                            </div>

                            <TextField
                                label="Correo Electrónico"
                                value={formValues.email}
                                onChange={(e) => setFormValues({ ...formValues, email: e.target.value })}
                                error={formValues.email !== '' && !validateEmail(formValues.email)}
                                helperText={formValues.email !== '' && !validateEmail(formValues.email) ? 'Correo inválido' : ''}
                                variant="outlined"
                                fullWidth
                            />

                            <TextField
                                label="Contraseña"
                                type="password"
                                value={formValues.password}
                                onChange={(e) => setFormValues({ ...formValues, password: e.target.value })}
                                variant="outlined"
                                fullWidth
                            />

                            <TextField
                                label="Confirmar Contraseña"
                                type="password"
                                value={formValues.confirm_password}
                                onChange={(e) => setFormValues({ ...formValues, confirm_password: e.target.value })}
                                error={formValues.password !== formValues.confirm_password && formValues.confirm_password !== ''}
                                helperText={formValues.password !== formValues.confirm_password && formValues.confirm_password !== '' ? 'Las contraseñas no coinciden' : ''}
                                variant="outlined"
                                fullWidth
                            />


                            <LoadingButton
                                size="small"
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ fontSize: '13px', padding: '10px 0px' }}
                                onClick={submit}
                                disabled={!fieldsCompleted || loadingButton}
                                loading={loadingButton}
                            >
                                Registrarme
                            </LoadingButton>
                        </>
                    )}
                    
                </div>
            </Box>

            {/* Alerta de certificados para kinesiólogos recién registradas */}
            <Dialog open={nurseAlertOpen} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ fontWeight: 700, fontSize: 19, pb: 0 }}>
                    🎉 ¡Registro exitoso!
                </DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                        <span style={{ fontSize: 30, flexShrink: 0 }}>📋</span>
                        <p style={{ margin: 0, color: '#374151', lineHeight: 1.7, fontSize: 15 }}>
                            Recuerda subir tus <strong>certificados y credenciales profesionales</strong> en tu perfil para quedar aprobado como kinesiólogo verificado. De lo contrario, nos contactaremos contigo para solicitarlos.
                        </p>
                    </div>
                </DialogContent>
                <DialogActions sx={{ p: '12px 24px 20px' }}>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={() => { setNurseAlertOpen(false); window.location.href = '/login'; }}
                    >
                        Entendido, iniciar sesión
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
